import styled from 'styled-components';

import { useAccountModalDispatch } from 'account/hooks/useAccountModal';
import { AccountModalActions } from 'account/state/accountModalReducer';
import {
  AccountDropdownMenuButton,
  AccountDropdownMenuList,
  AccountDropdownMenuListItem,
  AccountDropdownMenuWrapper,
} from 'layout/header/styles/AccountDropdownMenu';
import { UnorderedList } from 'shared/components';
import { useSitePreferencesModal } from 'shared/hooks/useSitePreferencesModal';
import { useTranslation } from 'react-i18next';

export const LoggedOutDropdownMenu = () => {
  const dispatch = useAccountModalDispatch();
  const { openSitePreferencesModal } = useSitePreferencesModal();
  const { t } = useTranslation();

  const handleCreateAccountClick = () => {
    dispatch({ type: AccountModalActions.openCreateAccountModal });
  };

  const handleLogInClick = () => {
    dispatch({ type: AccountModalActions.openLogInModal });
  };

  return (
    <LoggedOutDropdownMenu.Wrapper>
      <LoggedOutDropdownMenu.List>
        <LoggedOutDropdownMenu.ListItem>
          <LoggedOutDropdownMenu.Button
            data-qa="log_in_menu_button"
            onClick={handleLogInClick}
            type="button"
          >
            {t('layout.header.logIn', 'Log In')}
          </LoggedOutDropdownMenu.Button>
        </LoggedOutDropdownMenu.ListItem>
        <LoggedOutDropdownMenu.ListItem>
          <LoggedOutDropdownMenu.Button
            data-qa="create_account_menu_button"
            onClick={handleCreateAccountClick}
            type="button"
          >
            Create&nbsp;Account
          </LoggedOutDropdownMenu.Button>
        </LoggedOutDropdownMenu.ListItem>
        <LoggedOutDropdownMenu.ListItem>
          <LoggedOutDropdownMenu.Button
            data-qa="location_preference_menu_button"
            onClick={openSitePreferencesModal}
            type="button"
          >
            {t('layout.header.locationPreferences', 'Location Preferences')}
          </LoggedOutDropdownMenu.Button>
        </LoggedOutDropdownMenu.ListItem>
      </LoggedOutDropdownMenu.List>
    </LoggedOutDropdownMenu.Wrapper>
  );
};

LoggedOutDropdownMenu.Wrapper = styled.div`
  ${AccountDropdownMenuWrapper};
`;

LoggedOutDropdownMenu.List = styled(UnorderedList)`
  ${AccountDropdownMenuList};
`;

LoggedOutDropdownMenu.ListItem = styled.li`
  ${AccountDropdownMenuListItem};
`;

LoggedOutDropdownMenu.Button = styled.button`
  ${AccountDropdownMenuButton};
`;
